import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';



@Injectable({
  providedIn: 'root'
})
export class AgnoskojService {

  constructor(
    private http: HttpClient,
  ) { }

  getAgnoskoj(): Observable<any> {
    return this.http.get(Services.agnoskoj);
  }
}
